// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep .read-more span{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.video-card{margin:0 !important}.video-card::before{display:none}.video-card h2{word-break:normal}@media only screen and (max-width: 959px){.video-card h2{font-size:1.25rem}}@media only screen and (max-width: 959px){.video-card p{font-size:.825rem}}.video-card .description a{text-decoration:underline}.live-event-card h2{font-size:1.25rem !important}", ""]);
// Exports
module.exports = exports;
